import React from "react";
import "./Homepage.css";
import CountInventory from "./CountInventory";
import CountInvoice from "./CountInvoice";
import CountStock from "./CountStock";
import CountReport from "./CountReport";
import Chart from "../Chart/Chart";

const Homepage = () => {

    return (
        <>
            <div className="home-main">
                <div className="">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <CountInvoice />
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <CountInventory />
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <CountStock />
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <CountReport />
                        </div>
                    </div>
                    <div className="row">
                        <Chart />
                    </div>
                </div>
            </div>
            {/* <button className="logout-btn" onClick={() => updateUser({})} >
                Logout
            </button> */}
        </>
    );
}

export default Homepage;